<!--
***********************
***** PLEASE READ *****
***********************
This component contains three sections with the first being for the Digital/web version.
The second and third are for the print PDF version.
If any generic amends are made, please check and ensure they are made to both sections if required.
-->

<!-- Start: Digital/Web page only -->
@if (!isPrintPDFRoute) {
  <section class="section section--financial-rewards pdf-page-wrapper">
    <div class="container">
      <h2 [innerText]="'Your financial rewards.' | translate" class="secondary-heading mb-3"></h2>
      <h3 [innerText]="'Tap a reward to find out more.' | translate" class="tertiary-heading hide-for-print"></h3>
      <div (click)="openModal(template)" (keydown.enter)="openModal(template)" role="button" tabindex="0"
        [ngClass]="{'reward--mobile':isMobileStyles, 'hide-figures':isFiguresHide, 'show-figures':!isFiguresHide}"
        [ngStyle]="{'height': innerCircleSize + 'px', 'width': innerCircleSize + 'px'}" class="reward reward--rank-1 reward--pos-1">
        <div class="reward--pos-1-inner">
          <h4 [innerText]="innerCircleName"
          [ngStyle]="{'font-size': innerCircleTextScale * 1.5 + 'em'}" class="quaternary-heading quaternary-heading--financial-rewards fr-name print-only__secondary-heading"></h4>
          @if (!isFiguresHide) {
            <h4
              [innerText]="innerCircleValue | currency:currency:'symbol':'1.2-2'"
              [ngStyle]="{'font-size': innerCircleTextScale * 1.5 + 'em'}"
            class="quaternary-heading quaternary-heading--financial-rewards fr-user-value"></h4>
          }
          <div class="print-only">
            @if (!isFiguresHide) {
              <h3 class="tertiary-heading tertiary-heading--modal d-flex">
                <span [innerText]="'Value to you:' | translate" class="d-inline-block"></span>&nbsp;
                <span [innerText]="innerCircleValue | currency:currency:'symbol':'1.2-2'"
                class="d-inline-block ml-auto"></span>
              </h3>
            }
            @if (innerCircleLongDescription) {
              <p [innerText]="innerCircleLongDescription"></p>
            }
          </div>
        </div>
        <ng-template #template>
          <div class="modal-header modal-header--financial-rewards">
            <div class="modal-header__left">
              <h2 [innerText]="innerCircleName + '.'"
              class="secondary-heading secondary-heading--modal secondary-heading--modal-financial-rewards pull-left"></h2>
              @if (reward) {
                <div class="categories">
                  <!-- For the largest value in the center circle which will be the first item in the financialRewards array -->
                  @for (cat of reward.categories; track trackByFn($index, cat)) {
                    <span class="category-label category-label--{{cat.toLowerCase()}}"
                    [innerText]="cat"></span>
                  }
                </div>
              }
            </div>
            @if (!isFiguresHide) {
              <div class="modal-header__right">
                <h3 class="tertiary-heading tertiary-heading--modal-financial-rewards">
                  <span [innerText]="'Value to you:' | translate" class="modal-header__value-text"></span>
                  <span [innerText]="innerCircleValue | currency:currency:'symbol':'1.2-2'"
                    class="modal-header__value-figure">
                  </span>
                </h3>
              </div>
            }
          </div>
          <button (click)="modalRef.hide()" aria-label="Close" class="modal__close pull-right" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-body">
            @if (innerCircleLongDescription) {
              <p [innerText]="innerCircleLongDescription"></p>
            }
          </div>
        </ng-template>
        @for (reward of financialRewards; track trackByFn(rewardIndex, reward); let rewardIndex = $index) {
          <!-- Outer circles -->
          @if (rewardIndex > 0) {
            <div (click)="openModal2(template2, reward, $event)" (keydown.enter)="openModal2(template2, reward, $event)" role="button" tabindex="0"
             [ngStyle]="{
                 'height': reward.size + 'px',
                 'width': reward.size + 'px',
                 'margin-left': '-' + reward.size / 2 + 'px',
                 'margin-top': '-' + reward.size / 2 + 'px',
                 'transform': 'rotate('+ reward.degrees + 'deg) translate('+reward.translateValue+')'
                 }"
              class="reward reward--outer reward--{{formatDataToLowercaseNoSpacesWithHyphens(reward.name)}} reward--rank-{{rewardIndex + 1}} reward--pos-{{reward.outerCirclePosition}}">
              <div [ngStyle]="{'transform': 'rotate('+reward.contentRotateReset+ 'deg)'}" class="reward__content">
                <h4 [innerText]="useFullNameOrAbbreviated(reward.name, reward.abbreviation, reward.size)"
                  [ngStyle]="{'font-size': reward.textScale + 'em'}"
                class="quaternary-heading quaternary-heading--financial-rewards fr-name hide-for-print"></h4>
                @if (!isFiguresHide) {
                  <h4
                    [innerText]="reward.value | currency:currency:'symbol':'1.2-2'"
                    [ngStyle]="{'font-size': reward.textScale + 'em'}"
                  class="quaternary-heading quaternary-heading--financial-rewards fr-user-value"></h4>
                }
                <div class="print-only">
                  <!-- Showing full reward names for web page print -->
                  <h4 [innerText]="reward.name"
                    [ngStyle]="{'font-size': reward.textScale + 'em'}"
                  class="quaternary-heading quaternary-heading--financial-rewards fr-name print-only__secondary-heading"></h4>
                  @if (!isFiguresHide) {
                    <h3 class="tertiary-heading tertiary-heading--modal d-flex">
                      <span [innerText]="'Value to you:' | translate" class="d-inline-block"></span>&nbsp;
                      <span [innerText]="reward.value | currency:currency:'symbol':'1.2-2'"
                      class="d-inline-block ml-auto"></span>
                    </h3>
                  }
                  @if (reward.longDescriptionDigital) {
                    <p [innerText]="reward.longDescriptionDigital"></p>
                  }
                </div>
              </div>
            </div>
            }<!-- Close outer circles -->
            <ng-template #template2>
              <div class="modal-header modal-header--financial-rewards">
                <div class="modal-header__left">
                  <h2
                    [innerText]="reward.name + '.'"
                  class="secondary-heading secondary-heading--modal secondary-heading--modal-financial-rewards pull-left"></h2>
                  @if (reward) {
                    <div class="categories">
                      @for (cat of reward.categories; track trackByFn($index, cat)) {
                        <span class="category-label category-label--{{cat.toLowerCase()}}"
                        [innerText]="cat"></span>
                      }
                    </div>
                  }
                </div>
                @if (!isFiguresHide) {
                  <div class="modal-header__right">
                    <h3 class="tertiary-heading tertiary-heading--modal-financial-rewards">
                      <span [innerText]="'Value to you:' | translate" class="modal-header__value-text"></span>
                      <span [innerText]="reward.value | currency:currency:'symbol':'1.2-2'"
                        class="modal-header__value-figure">
                      </span>
                    </h3>
                  </div>
                }
              </div>
              <div class="modal-body">
                @if (reward.longDescriptionDigital) {
                  <p [innerText]="reward.longDescriptionDigital"></p>
                }
              </div>
              <button (click)="modalRef.hide()" aria-label="Close" class="modal__close pull-right" type="button">
                <span aria-hidden="true">&times;</span>
              </button>
            </ng-template>
          }
        </div><!-- Close inner circle -->
        @if (!isFiguresHide) {
          <h3 class="tertiary-heading">{{ 'This adds up to' | translate }}
            <strong>{{ getFinancialTotal() | currency:currency:'symbol':'1.0-2' }}</strong></h3>
          }
        </div>
      </section>
    }
    <!-- End: Digital/Web page only -->

    <!-- Start: PDF print only -->
    @if (isPrintPDFRoute) {
      <!-- Page 1 -->
      <section class="section section--financial-rewards section--financial-rewards-page-1 pdf-page-wrapper">
        <h2 [innerText]="'Your financial rewards.' | translate" class="secondary-heading"></h2>
        <h3 [innerText]="'Just a few of the ways we say thank you. ' | translate" class="tertiary-heading"></h3>
        <div class="row justify-content-center">
          @if (usersFinancialRewardsLengthForPdf > 1) {
            <div class="pdf-print-column">
              @for (reward of financialRewards; track trackByFn(rewardIndex, reward); let rewardIndex = $index) {
                @if (rewardIndex < 2) {
                  <ng-container
                  *ngTemplateOutlet="rewardTemplate; context:{ $implicit: reward, idx: rewardIndex }"></ng-container>
                }
              }
            </div>
          }
          @if (usersFinancialRewardsLengthForPdf > 2) {
            <div class="pdf-print-column pdf-print-column--left-border">
              @for (reward of financialRewards; track trackByFn(rewardIndex, reward); let rewardIndex = $index) {
                @if (rewardIndex > 1 && rewardIndex < 4) {
                  <ng-container
                  *ngTemplateOutlet="rewardTemplate; context:{ $implicit: reward, idx: rewardIndex }"></ng-container>
                }
              }
            </div>
          }
          @if (usersFinancialRewardsLengthForPdf > 4) {
            <div class="pdf-print-column pdf-print-column--left-border">
              @for (reward of financialRewards; track trackByFn(rewardIndex, reward); let rewardIndex = $index) {
                @if (rewardIndex > 3 && rewardIndex < 6) {
                  <ng-container
                  *ngTemplateOutlet="rewardTemplate; context:{ $implicit: reward, idx: rewardIndex }"></ng-container>
                }
              }
            </div>
          }
        </div>
      </section>
      <!-- End of page 1 -->
      <!-- Page 2 (if user has more than 6 rewards) -->
      @if (isPageTwoNeededForPdf) {
        <section
          class="section section--financial-rewards section--pdf-page-2 pdf-page-wrapper">
          <h2 [innerText]="'Your financial rewards.' | translate" class="secondary-heading"></h2>
          <div [innerText]="'(continued)' | translate" class="pdf-page2-continued"></div>
          <div class="row justify-content-center">
            @if (usersFinancialRewardsLengthForPdf > 6) {
              <div class="pdf-print-column">
                @for (reward of financialRewards; track trackByFn(rewardIndex, reward); let rewardIndex = $index) {
                  @if (rewardIndex > 5 && rewardIndex < 8) {
                    <ng-container
                    *ngTemplateOutlet="rewardTemplate; context:{ $implicit: reward, idx: rewardIndex }"></ng-container>
                  }
                }
              </div>
            }
            @if (usersFinancialRewardsLengthForPdf > 8) {
              <div class="pdf-print-column pdf-print-column--left-border">
                @for (reward of financialRewards; track trackByFn(rewardIndex, reward); let rewardIndex = $index) {
                  @if (rewardIndex > 7 && rewardIndex < 10) {
                    <ng-container
                    *ngTemplateOutlet="rewardTemplate; context:{ $implicit: reward, idx: rewardIndex }"></ng-container>
                  }
                }
              </div>
            }
          </div>
        </section>
      }
      <!-- End of page 2 -->
    }

    <!--reward block template reused in print pdf columns above-->
    <ng-template #rewardTemplate let-reward let-index="idx">
      <div class="block block--rank-{{index + 1}}">
        <div class="block__content">
          <h4 class="quaternary-heading">
            <span [innerText]="reward.name"></span>
            <span [innerText]="reward.value | currency:currency:'symbol':'1.2-2'"></span>
          </h4>
          <p [innerText]="reward.shortDescriptionPrint"></p>
        </div>
      </div>
    </ng-template>
    <!-- End: PDF print only -->
